import { Flex } from 'antd'
import Image from '@/components/image'
import Icon, { IconName } from '@/components/icon'
import imageEnable1 from '@/assets/img/solution/disaster-relief/enable-1.jpg'
import imageEnable2 from '@/assets/img/solution/disaster-relief/enable-2.jpg'
import imageEnable3 from '@/assets/img/solution/disaster-relief/enable-3.jpg'
import imageEnable4 from '@/assets/img/solution/disaster-relief/enable-4.jpg'
import Styles from './style.module.scss'

interface DataItemProps {
  icon: IconName
  title: string
  description: string
  image: string
}

const TITLE = 'What It Enables'
const data: DataItemProps[] = [
  {
    icon: 'blueBattery',
    title: 'Medical & Relief Centers',
    description:
      'Continuous power for clinics,field hospitals, and life-support equipment;maintaining vaccine cold chains',
    image: imageEnable1,
  },
  {
    icon: 'blueSignal',
    title: 'Emergency Communications',
    description: 'Stable power for mobile base stations, disaster command posts, and field radios',
    image: imageEnable2,
  },
  {
    icon: 'blueRotate',
    title: 'Shelters & Community Spaces',
    description: 'Quiet, safe, low-emission power for evacuation centers, food stations, and community hubs',
    image: imageEnable3,
  },
  {
    icon: 'blueTowerCrane',
    title: 'Recovery & Reconstruction',
    description: 'Power for pumping, lighting, tools, and temporary worksites during rebuilding efforts',
    image: imageEnable4,
  },
]

export default function Enable() {
  return (
    <div className={Styles.enable}>
      <h2>{TITLE}</h2>
      <div className={Styles.content}>
        {data.map((item, index) => (
          <Flex vertical key={index} className={Styles.item}>
            <Icon name={item.icon} className={Styles.icon} />
            <div className={Styles.title}>{item.title}</div>
            <div className={Styles.description}>{item.description}</div>
            <Image src={item.image} alt={item.title} rootClassName={Styles.image} />
          </Flex>
        ))}
      </div>
    </div>
  )
}
